const Promise = window.Promise || require('promise')

const generateResponse = (res) => {
  if (res.status === 200) {
    if (res.data.status === 'ok') {
      return Promise.resolve(res.data)
    } else {
      return Promise.reject({
        status: 'err',
        messages: res.data.messages,
        results: []
      })
    }
  } else {
    return Promise.reject({
      status: 'err',
      messages: res.data.messages
    })
  }
}
const generateErrorResponse = (err) => {
  if (typeof err.response.status !== 'undefined' &&
    err.response.status === 404
  ) {
    return Promise.reject({
      status: 'err',
      code: err.response.status,
      messages: err.response.data.messages,
      results: []
    })
  } else {
    return Promise.reject({
      status: 'err',
      code: err.response.status,
      messages: err.response.data.messages
    })
  }
}

export { generateResponse, generateErrorResponse }



// WEBPACK FOOTER //
// ./src/api/common.js